import * as React from 'react';

const SchibstedAccountInfo = () => (
  <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
    <p className="text-left" style={{ fontSize: '.7rem' }}>
      Vi bruker dette for å finne ut om du har en konto. Dersom du ikke har en
      Schibsted-konto fra før vil vi opprette en konto til deg for å fullføre
      kjøpet. Dersom kjøpet blir avbrutt sender vi en e-post for å hjelpe deg
      med å fullføre kjøpet på et senere tidspunkt.
    </p>
  </div>
);

export default SchibstedAccountInfo;



// WEBPACK FOOTER //
// ./src/gdpr/ShibstedAccountInfo.tsx